import { handleGainSightEventForPageVisit } from './gainSightIntegration';

export const handlePageVisitData = (location) => {
    const pageVisitData = {
      pageUrl: location.href,
      pageBaseUrl: `${location.protocol}//${location.host}`,
    }
    handleGainSightEventForPageVisit(pageVisitData);
}

export const isFeatureEnabled = (feature, features = {}) => {
  return features?.[feature] === true;
}
